import React, { useCallback, useEffect, useState } from "react";
import { SzBox } from "@suezenv/react-theme-components";
import JsonViewer from "./json-viewer/JsonViewer";
import reportRepository from "../../../../services/api/repository/report-repository";
import { JsonType, MetadataType } from "../../../../services/types/report";
import { useTranslation } from "react-i18next";
interface Props {
  contractId: string;
  templateName: string;
}
export const TemplateMetadataEdit: React.FC<Props> = ({ contractId, templateName }) => {
  const { t } = useTranslation("setting");
  const [metadata, setMetadata] = useState<MetadataType>();
  const saveMetadata = useCallback(
    (data: JsonType) => {
      reportRepository.editTemplateMetadata(contractId, templateName, data as MetadataType);
    },
    [contractId, templateName],
  );
  useEffect(() => {
    reportRepository.getTemplate(contractId, templateName).then((response) => {
      setMetadata(response.data.templateMetadatas);
    });
  }, [contractId, templateName]);
  return (
    <SzBox className="row my-4 report" tag="div">
      <div className="col mt-4">
        {t("report.container.metadataTitle", { templateName: templateName })}
        <div className="row">
          <div className="col">{metadata && <JsonViewer data={metadata} save={saveMetadata} />}</div>
        </div>
      </div>
    </SzBox>
  );
};

export default TemplateMetadataEdit;
